import React from "react";
import "./columnItem.less";
import ShowMoreText from "react-show-more-text";
import IntlMessages from "@util/IntlMessages";

const ColumnItem = ({ title, row, showTitle }) => {
   return (
      <div className="gx-product-body-column">
         <ShowMoreText
            lines={3}
            more={<IntlMessages id="advertismentList.showMore" />}
            less={<IntlMessages id="advertismentList.showLess" />}
            className="show-more-text-container"
            anchorClass="custom-color"
         >
            {showTitle && <>{title}:</>} {row}
         </ShowMoreText>
      </div>
   );
};

export default ColumnItem;
